import styled from 'styled-components';

export const ContainerIndicaMais = styled.div`
  display: flex;
  height: fit-content;
  box-sizing: border-box;
  justify-content: center;
  align-items: center;
  gap: 109px;
  border-radius: 8px;
  margin: 40px auto;
  padding-right: 24px;
  padding-right: 24px;
  background-color: ${({ tema }) => tema?.primaryColor};

  .container-infos-indica-mais {
    display: flex;
    flex-direction: column;

    justify-content: center;

    .title-indica-mais,
    .subtitle-indica-mais {
      color: #fff;
    }

    .title-indica-mais {
      font-size: 48px;
      font-weight: bold;
      line-height: 60px;
      margin: 0;
    }

    .subtitle-indica-mais {
      font-size: 20px;
      font-weight: 400;
      line-height: 30px;
      margin-top: 8px;
      margin-bottom: 24px;
    }

    .container-buttons-indica-mais {
      display: flex;
      gap: 24px;
    }
  }

  @media (max-width: 768px) {
    flex-direction: column-reverse;
    padding: 16px;
    padding-bottom: 0;
    padding-top: 24px;
    gap: 50px;

    .container-infos-indica-mais {
      .title-indica-mais {
        font-size: 28px;
        line-height: 32px;
        text-align: center;
      }

      .subtitle-indica-mais {
        font-size: 16px;
        line-height: 24px;
        text-align: center;
      }

      .container-buttons-indica-mais {
        display: flex;
        flex-direction: column;
        gap: 24px;
      }
    }
  }
`;
